import { ActionTypes } from 'utils/constants';
import { getDeepProp } from 'utils/get-deep-prop';

const initialState = {};

export const confirmEmail = (state = initialState, action) => {
    switch(action.type) {
        case ActionTypes.CONFIRM_EMAIL + '_PENDING': {
            return {
                ...state,
                processing: true
            };
        }
        case ActionTypes.CONFIRM_EMAIL + '_REJECTED': {
            const error = getDeepProp(action, 'payload', 'response', 'data', 'msg');

            return {
                ...state,
                error
            };
        }
        case ActionTypes.CONFIRM_EMAIL + '_FULFILLED': {
            return {
                ...state,
                complete: true,
                processing: false
            };
        }
        default: {
            return state;
        }
    }
};
